import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  employeeId: 0,
  deleteReasonId: 0,
  stationId: 0,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')
    systemSettingApi.getOrderCancellationSettings()
      .then(({ data }) => commit('ORDER_CANCELLATION_SETTING_FETCHED', data))
      .catch(err => commit('ORDER_CANCELLATION_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateOrderCancellationSettings(state)
      .then(({ data }) => commit('ORDER_CANCELLATION_SETTING_UPDATED', data))
      .catch(error => {
        commit('ORDER_CANCELLATION_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  ORDER_CANCELLATION_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  ORDER_CANCELLATION_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ORDER_CANCELLATION_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
